import { SystemAccount, UserAccount } from '@audibene/ta.utils-opportunity'
import { IdentityAccount } from 'types'

enum RelatedEntityType {
  APPOINTMENT = 'APPOINTMENT',
  COUPLING = 'COUPLING',
  CUSTOMER = 'CUSTOMER',
  OPPORTUNITY = 'OPPORTUNITY',
  POST = 'POST',
}

enum NoteServiceNoteType {
  FINANCIAL = 'FINANCIAL',
  GENERAL = 'GENERAL',
}

export type HumanAuthor = {
  familyName: string
  givenName: string
  user?: UserAccount
}

type Author = SystemAccount | HumanAuthor

type ContentSource = 'AI_GENERATED' | 'HUMAN'

type InteractionType = 'PINNED' | 'READ'
interface Interaction {
  createdBy: UserAccount
  createdAt: Date
  id: string
  relatedGid: string
  relatedType: 'NOTE' | 'COMMENT'
  type: InteractionType
}

interface Note {
  author: Author
  content?: string
  contentSource?: ContentSource
  createdAt: Date
  createdBy?: IdentityAccount
  customerGid: string
  customerSalesforceId: string
  gid?: string
  id: string
  opportunityGid?: string
  opportunitySalesforceId: string
  relatedEntityGid: string
  relatedEntityType: RelatedEntityType
  // Note-service discriminator on the notes-list response (e.g. FINANCIAL, GENERAL).
  // NOTE: the response field is `type` — not `noteType`. The notes-list read endpoint also
  // accepts `type` as a query param to filter by kind (see useLatestFinancialNote).
  type?: NoteServiceNoteType
  updatedAt: Date
  updatedBy: IdentityAccount
  wasEdited: boolean
  interactions?: Interaction[]
}

enum CommentParentType {
  NOTE = 'NOTE',
}

type Comment = {
  author: Author
  content: string
  createdAt: Date
  createdBy: IdentityAccount
  gid: string
  parentGid: string
  parentType: CommentParentType
  updatedAt: Date
  updatedBy: IdentityAccount
  wasEdited: boolean
}

export type { Note, Author, Comment, Interaction, InteractionType, ContentSource }
export { CommentParentType, NoteServiceNoteType, RelatedEntityType }
